



















































































































































/* eslint-disable no-unused-vars */
import BaseForm from '@/views/BaseForm';
import { Component, Watch } from 'vue-property-decorator';
import PasswordChange from '@/components/PasswordChange.vue';
import { AxiosResponse } from 'axios';
import { userMdl } from '@/models/userMdl';
import { corpMdl } from '@/models/corpMdl';
import mapStyles from '@/assets/json/gmapstyle.json';
/* eslint-enable no-unused-vars */

interface MapStyle {
    [key: string]: any;
}

@Component({
    name: 'user_edit',
    components: { PasswordChange },
    head: {
        title: {
            inner: 'ユーザ登録',
            separator: '-',
            complement: 'Battery-Surveillance',
        },
    },
})
export default class user_edit extends BaseForm {
    private userData: userMdl = new userMdl();
    private isFormValid: boolean = false; // バリデーション状態でボタンを有効化する為のフラグ
    private showPassword: boolean = false; // パスワード表示
    private showConfirmPassword: boolean = false; // パスワード確認表示
    private passwordChangeFlg: boolean = false;
    private MapStyleObject: MapStyle = mapStyles;
    private selectmapstyle: any = [];
    private localAuthorityList: any;

    private corpDataList: corpMdl[] = []; // 会社データ一覧

    get refs(): any {
        return this.$refs;
    }

    async created() {
        // 自分の権限に応じて権限セレクトの内容変更
        if (this.authority > 2) {
            this.localAuthorityList = this.authorityListTop;
            this.getCorpList();
        } else {
            this.localAuthorityList = this.authorityList;
        }
        // user_idがURLに付与されている場合は更新の為データ取得
        if (this.$route.query['user_id']) {
            await this.getUserData(Number(this.$route.query['user_id']));
        }
        this.changeAuthority();

        this.selectmapstyle = Object.entries(this.MapStyleObject).map(([key]) => ({ value: key, text: key }));
    }

    // データ取得処理
    private async getUserData(user_id: number) {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = { user_id: user_id };
            const resp: AxiosResponse<any> = await this.$http.post('user_data.php', params, {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                    this.userData = new userMdl(userMdl.toJsonDataOnModel(resp.data.items[0]));
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                case 'DATA_NOTFOUND_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // 会社一覧の取得
    private async getCorpList() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            const resp: AxiosResponse<any> = await this.$http.post('corp_data.php', '', {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                case 'DATA_NOTFOUND_ERROR':
                    this.corpDataList = resp.data.items.map(function(v: any) {
                        return new corpMdl(corpMdl.toJsonDataOnModel(v));
                    });
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // 登録処理
    private async onClickEdit() {
        if (this.refs.form.validate() === false) {
            // 入力チェックで不備あり判定の為、後続処理は行わない
            return;
        }

        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            const resp: AxiosResponse<any> = await this.$http.post('user_edit.php', this.userData, {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                    // if (this.authority > 0) {
                    // ユーザ一覧画面へ遷移
                    this.$router.push({ path: '/user_list' }, () => {});
                    // } else {
                    //     // マップ画面へ遷移
                    //     this.$router.push({ path: '/pmap' }, () => {});
                    // }
                    break;
                case 'VALIDATION_ERROR':
                    // バリデーションエラーメッセージをセット
                    this.validationErrors = resp.data.errors;
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'SAVE_FAILED_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'ユーザ登録失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'ユーザ登録失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // 一覧に戻る
    private onClickReturn() {
        this.$router.push({ path: '/user_list' }, () => {});
    }

    @Watch('userData.corp_id')
    private changeAuthority() {
        // システム管理者の場合のみ
        if (this.authority > 2) {
            let disabled_flg = true;
            if (this.userData.corp_id == 0) {
                disabled_flg = false;
                // 権限でシステム管理者以外が選ばれてる場合システム管理者にする
                if (this.userData.authority != 3) {
                    this.userData.authority = 3;
                }
            } else {
                // 権限でシステム管理者が選ばれてる場合一般にする
                if (this.userData.authority == 3) {
                    this.userData.authority = 1;
                }
            }
            for (let i = 0; i < this.localAuthorityList.length; ++i) {
                if (this.localAuthorityList[i].value == 3) {
                    this.localAuthorityList[i].disabled = disabled_flg;
                } else {
                    this.localAuthorityList[i].disabled = !disabled_flg;
                }
            }
        }
    }

    // パスワード変更
    private onClickPasswordChange() {
        this.passwordChangeFlg = true;
    }
    private passwordChangeClose() {
        this.passwordChangeFlg = false;
    }
}
